export default {"src":"/_next/static/media/premiumhandichiens.ac79a927.svg","height":36,"width":35,"blurWidth":0,"blurHeight":0};